import React, {Component, Fragment} from "react";
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import axios from "axios";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {Badge, Form} from "react-bootstrap";
import draftToHtml from "draftjs-to-html";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonGroup from "react-bootstrap/ButtonGroup";
import {faPen, faXmark, faEye} from '@fortawesome/free-solid-svg-icons';
import Table from "react-bootstrap/Table";
import Moment from "moment/moment";

class BlogsAdmin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            blogsdatas: [],
            blogeditdatas: [],
            blogdatas: [],
            showmod : false,
            showeditblog : false,
            check: false,
            wysi : null,
            setEditBlog : null,
            switchValue: false,
            tagsdatas : []
        };
    }

    mytoken = JSON.parse(localStorage.getItem('token')).token;
    config = {
        headers: { Authorization: `Bearer ${this.mytoken}` }
    };

    getblogs(){
        axios.get(process.env.REACT_APP_API_URLSF+`/api/blogs`, this.config)
            .then(res => {
                this.setState({blogsdatas : res.data.blogs });
            })
            .catch(err => console.error(err));
    }
     handleShow() {
         this.setState({showmod : true })
         this.setState({blogdatas : ''})
         const html = '<p>Add a descrition <strong>Here</strong>😀</p>';
         const contentBlock = htmlToDraft(html);
         if (contentBlock) {
             const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
             const editorState = EditorState.createWithContent(contentState);
             this.setState({editorState})
         }
     };
    handleClose() {
        this.setState({showmod : false })
        this.setState({showeditblog : false })
    };

    parseTags(e){
        return e.split(',').map((value, key)=> ({ [key]: value }) );
    };

    parseTagsAlt(array){
            let result = '';
            array.forEach(item => {
                if (Array.isArray(item)) {
                    // Si l'élément est un tableau, appliquer récursivement la fonction
                    result += this.parseTagsAlt(item);

                } else if (typeof item === 'object' && item !== null) {
                    // Si l'élément est un objet, parcourir ses clés et valeurs
                    for (const [key, value] of Object.entries(item)) {
                        result += `${value}, `;
                    }
                } else {
                    // Si c'est une valeur simple, l'ajouter directement
                    result += `${item},  `;
                }
            });
            // Retirer la dernière virgule et l'espace
            return result.slice(0, -2);

    };

    enable(){
        this.setState({value : false })
    };

    createblog = (e) => {
        e.preventDefault();
        let date = new Date();
        let currentdate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getUTCDay()}`;
        /** this.setState({blogdatas : {
                 title : e.target.elements[0].value,
                 myblog: this.state.wysi,
                 tags: this.parseTags(e.target.elements[2].value),
                 active: this.state.check,
                 datepost : currentdate+'T15:52:01+00:00'
         }})
         */
        this.state.blogdatas = {
            title : e.target.elements[0].value,
            myblog: this.state.wysi,
            tags: this.parseTags(e.target.elements[2].value),
            active: this.state.switchValue,
            datepost : currentdate+'T15:52:01+00:00'
        }

        const dataEncodedtoJson = JSON.stringify(this.state.blogdatas);
        axios.post(process.env.REACT_APP_API_URLSF+`/api/blog`, dataEncodedtoJson, this.config)
            .then(res => {
                res.status === 201 ?  this.getblogs() : console.log(res.status);
            })
            .then(res => {
            this.handleClose();
        })
            .catch(err => console.error(err));
    }

    editblog(id){
        this.setState({showeditblog : true })

        axios.get(process.env.REACT_APP_API_URLSF+`/api/blog/`+ id)
            .then(res => {
                this.setState({blogeditdatas : res.data})
                this.setState({switchValue : res.data.active })
                this.setState({tagsdatas : this.parseTagsAlt(res.data.tags)})
                const contentBlock = htmlToDraft(res.data.post);
                const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                const editorState = EditorState.createWithContent(contentState);
                this.setState({editorState : editorState });
            })
            .catch(err => console.error(err));
    }

    handleEdit = (e) => {
        e.preventDefault();
        let blogid = e.target.elements.blogid.value;

        this.state.blogdatas = {
            title : e.target.elements.title.value,
            post: this.state.wysi,
            tags: this.parseTags(e.target.elements.tag.value),
            active: this.state.switchValue

        }
        const dataEncodedtoJson = JSON.stringify(this.state.blogdatas);
        axios.put(process.env.REACT_APP_API_URLSF+`/api/blog/`+blogid, dataEncodedtoJson, this.config)
            .then(res => {
                res.status === 204 ?   this.getblogs() : console.log(res.status);
            })
            .then(res => {
                this.handleClose()
                })
            .catch(err => console.error(err));
    }
    handleSwitchChange = () => {
        this.setState(prevState => ({
            switchValue: !prevState.switchValue, // Inverse la valeur actuelle
        }), () => {
            console.log("Valeur du switch :", this.state.switchValue); // Affiche la valeur booléenne
        });
    };

     handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({blogeditdatas : {[name]: value} })
    };

    handleChangeTagdatas: Function = (e) => {
        const value = e.target.value;
        this.setState({tagsdatas : value})
    }
    deleteblog(id){
        axios.delete(process.env.REACT_APP_API_URLSF+`/api/blog/`+id, this.config)
            .then(res => {
                res.status === 204 ? this.getblogs() : console.log(res.status);
            })
            .catch(err => console.error(err));
    }

    componentDidMount() {
        this.getblogs();
        const html = '<p>Add a descrition <strong>Here</strong>😀</p>';
        const contentBlock = htmlToDraft(html);
        if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            const editorState = EditorState.createWithContent(contentState);
            this.setState({editorState})
        }
    }
    onEditorStateChange: Function = (editorState) => {
        this.setState({
            editorState,
        });
        this.setState({wysi : draftToHtml(convertToRaw(editorState.getCurrentContent())) })
    };
    render(){
        const { blogsdatas } = this.state;
        const { blogeditdatas } = this.state;
        const { editorState } = this.state;
         const {tagsdatas} = this.state;
            return(
            <Fragment>
                <section id="signup" className="signup-section">
                    <div className="container">
                        <h2>Gestion des blogs</h2>
                        <Button variant="primary" onClick={() => this.handleShow()}>
                            <FontAwesomeIcon icon={faPen} />
                        </Button>
                        <hr/>
                        <div className="align-self-center" key="CareerAdminAlign">
                            <Modal show={this.state.showmod} onHide={() => this.handleClose()}>
                            <Modal.Header closeButton  onClick={() => this.handleClose()}>
                                <Modal.Title>Create a new post in blog</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form onSubmit={this.createblog}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Control type="text" placeholder="Post title" name="blogtitle"/>
                                        <Editor
                                            editorState={editorState}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            onEditorStateChange={this.onEditorStateChange}
                                            toolbar={{
                                                image: {
                                                },
                                                colorPicker: {
                                                    className: undefined,
                                                    component: undefined,
                                                    popupClassName: undefined,
                                                    colors: ['rgb(97,189,109)', 'rgb(26,188,156)', 'rgb(84,172,210)', 'rgb(44,130,201)',
                                                        'rgb(147,101,184)', 'rgb(71,85,119)', 'rgb(204,204,204)', 'rgb(65,168,95)', 'rgb(0,168,133)',
                                                        'rgb(61,142,185)', 'rgb(41,105,176)', 'rgb(85,57,130)', 'rgb(40,50,78)', 'rgb(0,0,0)',
                                                        'rgb(247,218,100)', 'rgb(251,160,38)', 'rgb(235,107,86)', 'rgb(226,80,65)', 'rgb(163,143,132)',
                                                        'rgb(239,239,239)', 'rgb(255,255,255)', 'rgb(250,197,28)', 'rgb(243,121,52)', 'rgb(209,72,65)',
                                                        'rgb(184,49,47)', 'rgb(124,112,107)', 'rgb(209,213,216)'],
                                                },
                                            }}
                                        />
                                        <Form.Control type="textarea" placeholder="Tags" name="tag"/>
                                        {/*<Form.Check type="switch" id="custom-switch" name="enable" label="enable" onChange={(e) => this.setState({check: !this.state.check.value})} />*/}
                                        <Form.Check type="switch"
                                                    id="custom-switch"
                                                    name="enable"
                                                    label="enable"
                                                    checked={this.state.switchValue}
                                                    onChange={this.handleSwitchChange} />
                                             <input type="submit" value="Submit" className="btn btn-danger"/>
                                    </Form.Group>
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => this.handleClose()}>
                                    X
                                </Button>
                            </Modal.Footer>
                        </Modal>

                            <Modal show={this.state.showeditblog}  onHide={() => this.handleClose()}>
                                <Modal.Header closeButton  onClick={() => this.handleClose()}>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form onSubmit={this.handleEdit}>
                                        <Form.Control type="text" name="blogid" value={blogeditdatas.id} hidden={true}/>
                                        <Modal.Title>Edit this blog {blogeditdatas.id}</Modal.Title>
                                        <Form.Group className="mb-12 col-12 " controlId="formBasicEmail">
                                        <Form.Control type="text" name="title" value={blogeditdatas.title} onChange={this.handleChange}/>
                                        <Editor
                                            editorState={editorState}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            onEditorStateChange={this.onEditorStateChange}
                                            toolbar={{
                                                colorPicker: {
                                                    className: undefined,
                                                    component: undefined,
                                                    popupClassName: undefined,
                                                    colors:
                                                       ['rgb(97,189,109)', 'rgb(26,188,156)', 'rgb(84,172,210)', 'rgb(44,130,201)',
                                                        'rgb(147,101,184)', 'rgb(71,85,119)', 'rgb(204,204,204)', 'rgb(65,168,95)', 'rgb(0,168,133)',
                                                        'rgb(61,142,185)', 'rgb(41,105,176)', 'rgb(85,57,130)', 'rgb(40,50,78)', 'rgb(0,0,0)',
                                                        'rgb(247,218,100)', 'rgb(251,160,38)', 'rgb(235,107,86)', 'rgb(226,80,65)', 'rgb(163,143,132)',
                                                        'rgb(239,239,239)', 'rgb(255,255,255)', 'rgb(250,197,28)', 'rgb(243,121,52)', 'rgb(209,72,65)',
                                                        'rgb(184,49,47)', 'rgb(124,112,107)', 'rgb(209,213,216)'],
                                                    image: {
                                                        defaultSize: {
                                                            height: 'auto',
                                                            width: '100%',
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                        <Form.Control type="textarea" name="tag" value={tagsdatas} onChange={this.handleChangeTagdatas}/>
                                            <Form.Check aria-checked={true}
                                                        type="switch"
                                                        id="custom-switch"
                                                        name="enable"
                                                        label="enable"
                                                        checked={this.state.switchValue}
                                                        onChange={this.handleSwitchChange}
                                                        defaultChecked
                                            />
                                            <input type="submit" value="Submit" className="btn btn-danger"/>
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                            </Modal>
                        </div>
                        <div className="align-self-center">
                            <Table striped bordered hover>
                                <thead>
                                <tr>
                                    <th>id</th>
                                    <th>Titre du blog</th>
                                    <th>date posté</th>
                                    <th>status</th>
                                    <th>Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                {blogsdatas.map((item, key) => (
                                    <tr  key={item.id}>
                                        <th>{item.id}</th>
                                        <th>{item.title}</th>
                                        <th>{Moment(item.datepost).format("DD/MM/YYYY")}</th>
                                        <th>{item.active}{item.active ? (
                                            <Badge  key={key} pill bg="success">activé</Badge>
                                        ) : (
                                            <Badge  key={key} pill bg="danger">désactivé</Badge>
                                        )}</th>
                                        <th>
                                            <ButtonGroup aria-label="Basic example">
                                                <Button variant="success" onClick={() => this.editblog(item.id)}>
                                                    <FontAwesomeIcon icon={faPen}/>
                                                </Button>
                                                <Button variant="warning">
                                                    <FontAwesomeIcon icon={faEye} />
                                                </Button>
                                                <Button variant="danger" onClick={() => this.deleteblog(item.id)}>
                                                    <FontAwesomeIcon icon={faXmark} />
                                                </Button>
                                            </ButtonGroup>

                                        </th>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }
}

export default BlogsAdmin;